import api from './api';
import { Sitio } from '../types';

type SitiosApiResponse = Sitio[] | { data?: Sitio[]; total?: number };

export const getSitios = () =>
	api.get<SitiosApiResponse>('/sitios').then((res) => {
		const normalizedData = Array.isArray(res.data)
			? res.data
			: Array.isArray(res.data?.data)
				? res.data.data
				: [];

		if (!Array.isArray(res.data) && !Array.isArray(res.data?.data)) {
			console.warn('[sitios.service] Unexpected /sitios response shape', res.data);
		}

		return {
			...res,
			data: normalizedData,
		};
	});
export const getSitio = (id: string) => api.get<Sitio>(`/sitios/${id}`);
export const createSitio = (data: Partial<Sitio>) => api.post<Sitio>('/sitios', data);
export const updateSitio = (id: string, data: Partial<Sitio>) => api.patch<Sitio>(`/sitios/${id}`, data);
export const deleteSitio = (id: string) => api.delete(`/sitios/${id}`);
